<template>
  <div class="prompt-selector">
    <div class="prompt-list-container">
      <label>Select a prompt</label>
      <md-card class="prompt-list-card">
        <md-card-content class="prompt-list-card-content">
          <md-content class="md-scrollbar" style="height: 300px; overflow: auto">
            <div
              v-for="prompt in prompts"
              :key="prompt.id"
              class="prompt"
              :class="{ selected: state.selectedPrompt && prompt.id === state.selectedPrompt.id }"
              @click="selectPrompt(prompt)"
            >
              <span>{{ prompt.name.en }}</span>
            </div>
          </md-content>
        </md-card-content>
      </md-card>
    </div>
    <div class="prompt-preview-container">
      <label>Prompt Preview</label>
      <md-card class="prompt-list-card">
        <md-card-content class="prompt-list-card-content">
          <md-content class="md-scrollbar" style="height: 300px; overflow: auto">
            <html-editor
              v-if="show === 'contents'"
              :contents="selectedMarkup"
              :readonly="true"
              :show-border="false"
            />
            <div
              v-else
              class="description"
            >
              {{ selectedDescription }}
            </div>
          </md-content>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import HtmlEditor from '~lib/common/components/HtmlEditor/HtmlEditor.vue';

export default {
  name: 'prompt-selector',
  components: {
    HtmlEditor
  },
  props: {
    prompts: {
      type: Array,
      default: () => []
    },
    show: {
      type: String,
      default: 'description'
    }
  },
  data() {
    return {
      state: {
        selectedPrompt: null,
      }
    };
  },
  computed: {
    selectedMarkup() {
      let markup;
      if (this.state.selectedPrompt) {
        markup = this.state.selectedPrompt.value.markup.en;
      }
      return markup;
    },
    selectedDescription() {
      let description;
      if (this.state.selectedPrompt) {
        description = this.state.selectedPrompt.description.en;
      }
      return description;
    },
  },
  methods: {
    selectPrompt(prompt) {
      this.state.selectedPrompt = prompt;
      this.$emit('preview', prompt);
    },
  }
}
</script>

<style scoped>
.prompt-selector {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0;
}

.prompt-list-container,
.prompt-preview-container {
  flex: 1;
}

.prompt-list-container:first-child {
  margin-right: 14px;
}

.prompt-list-card-content {
  padding-bottom: 0 !important;
  padding: 1px;
  overflow: hidden;
}

.prompt {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 0.5px #d4d4d4;
  cursor: pointer;
}

.prompt.selected {
  color: #3f83c5;
}

.prompt:hover {
  background-color: #E0E0E0;
}

label {
  display: block;
  margin-bottom: 10px;
}

.description {
  padding: 6px 10px;
}
</style>